import { useEffect, useRef, useState } from "react";
import styles from "./HamburgerDropdown.module.css";
import useWindowSize from "../../hooks/useWindowSize";

function HamburgerDropdown({
    text,
    children,
    id,
    style,
    className,
    menuState,
}) {
    const [showDropdown, setShowDropdown] = useState(false);
    const containerRef = useRef(null);
    const childrenRef = useRef(null);
    const windowSize = useWindowSize();

    function handleClick() {
        setShowDropdown((prev) => !prev);
    }

    useEffect(() => {
        containerRef.current.style.setProperty(
            "--childrenHeight",
            `${childrenRef.current.offsetHeight + 16}px`
        );
    }, [windowSize]);

    useEffect(() => {
        if (!menuState) {
            setShowDropdown(false);
        }
    }, [menuState]);

    return (
        <div
            className={[
                styles.hamburger_dropdown_container,
                showDropdown ? styles.show : undefined,
            ].join(" ")}
            ref={containerRef}
        >
            <button
                id={id}
                className={[styles.hamburger_dropdown, className].join(" ")}
                style={style}
                onClick={handleClick}
            >
                {text}

                <img
                    src="/images/chevron-down-white.svg"
                    alt=""
                    className={styles.arrow}
                />
            </button>
            <div className={styles.children_overflow_container}>
                <div className={styles.children_container} ref={childrenRef}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default HamburgerDropdown;
